import React, { useState, useEffect, useCallback } from 'react'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import { Container } from 'reactstrap'
import moment from 'moment'
// LAP-733 (GE022) — load all 5 supported moment locales so the calendar can
// be rendered in any of fr/en/de/it/es. Default English is built-in.
import 'moment/locale/fr'
import 'moment/locale/de'
import 'moment/locale/it'
import 'moment/locale/es'
import { useTranslation } from 'react-i18next'

import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import { getColor } from './Colors'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css'
import './Calendar.scss'
import Year from './Year'
import YearEvent from './YearEvent'
import FormModal from './EventForm'
import { Event, MonthEvent, CustomAgendaEvent } from '../Components/CustomEvent'
import { makeGetRequest } from 'utils/api'
import { makePutRequest } from 'utils/api'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import TodayIcon from '@mui/icons-material/Today'
import CloseIcon from '@mui/icons-material/Close'
import {
  Box,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  useMediaQuery,
  useTheme,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material'
import AddConnection from 'Components/UserOptionCard/AddConnection'

import StarIcon from '@mui/icons-material/Star'
import StarBorderIcon from '@mui/icons-material/StarBorder'
import CustomButton from 'Components/CustomButton/CustomButton'
import { Padding } from '@mui/icons-material'
import { makePostRequest } from 'utils/api'
import urls from 'utils/urls'
import { useLocation } from 'react-router-dom'

const localizer = momentLocalizer(moment)

const DnDCalendar = withDragAndDrop(Calendar)

const getCalendarViewFromSearch = (search) => {
  const view = new URLSearchParams(search).get('view')
  return ['day', 'week', 'month', 'agenda', 'year'].includes(view) ? view : 'month'
}

const getCalendarDateFromSearch = (search) => {
  const date = new URLSearchParams(search).get('date')
  if (!date) return new Date()

  const parsedDate = new Date(date)
  return Number.isNaN(parsedDate.getTime()) ? new Date() : parsedDate
}

const Schedule = () => {
  const { t, i18n } = useTranslation('layout') // LAP-733 (GE022)
  // react-big-calendar's culture prop also controls moment formatting; mirror
  // the active i18next language and fall back to 'en' for anything unknown.
  const supportedCultures = ['fr', 'en', 'de', 'it', 'es']
  const activeCulture = supportedCultures.includes((i18n.language || '').slice(0, 2))
    ? i18n.language.slice(0, 2)
    : 'en'
  const location = useLocation()
  const allEvents = []
  const [finalEvents, setFinalEvents] = useState([])
  const [finalEventsTemp, setFinalEventsTemp] = useState([])
  const [taskList, setTaskList] = useState([])
  const [calendarView, setCalendarView] = useState(() => getCalendarViewFromSearch(location.search))
  const [calendarDate, setCalendarDate] = useState(() => getCalendarDateFromSearch(location.search))
  const [slot, setSlot] = useState({})
  const [openQue, setOpenQue] = useState(false)
  const [propsQue, setPropsQue] = useState(false)
  const [dragTask, setDragTask] = useState(false)
  const [platform, setPlatform] = useState('all')
  const [sync, setSync] = useState('select')
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [addGooglContact, setAddGooglContact] = useState(false)

  const [anchorEl, setAnchorEl] = useState(null)
  const openn = Boolean(anchorEl)
  const [openD, setOpenD] = useState(true) // For controlling the collapse state
  const [favoriteTasks, setFavoriteTasks] = useState([1, 2]) // Task IDs for favorites

  const handleDrawerToggle = () => {
    setOpenD(!openD)
  }

  const toggleFavorite = async (taskId) => {
    const res = await makePostRequest('/api/mestodo/task-favorit/', { id: taskId.id }, {}, true)
    if (res.status === 200) {
      getTaskList()
    }
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = (val = '') => {
    if (val) {
      syncCalender(val)
    } else {
      setAddGooglContact(false)
    }
    setAnchorEl(null)
  }
  // LAP-733 (GE022) — store the canonical platform key ('all' | 'google' | 'microsoft')
  // instead of the user-facing label so the UI can re-localize on language change.
  const [selectedCalender, setSelectedCalender] = useState('all')
  const [anchorEl2, setAnchorEl2] = useState(null)
  const openn2 = Boolean(anchorEl2)
  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget)
  }
  // LAP-733 (GE022) — switched to canonical platform keys ('all'/'Google'/'Microsoft').
  // Backend filter values for Google/Microsoft were already in English-cased strings
  // (event_source matches 'Google' / 'Microsoft'), so only the 'all' selection was
  // mixing locale text with state.
  const handleClose2 = (val = '') => {
    if (val) {
      setSelectedCalender(val)
      if (val === 'all') {
        setFinalEvents(finalEventsTemp)
      }
      if (val === 'Google') {
        setFinalEvents(finalEventsTemp.filter((e) => e.event_source === val))
      }
      if (val === 'Microsoft') {
        setFinalEvents(finalEventsTemp.filter((e) => e.event_source === val))
      }
    }
    setAnchorEl2(null)
  }

  const createFixedEvents = (events, categoryDD) => {
    const fEvents = events.filter((x) => x.event_type === 'f')
    fEvents.forEach((e) => {
      if (e.years) {
        const startDate = new Date(`${e.day_num}-${e.month_num}-${e.years}`)
        e.start = startDate
        allEvents.push(e)
      } else {
        const startYear = 2000
        const lastYear = 2030
        // make events for all years in range 2000-2030
        for (let i = startYear; i < lastYear; i++) {
          let d = `${i}-${e.day_num}-${e.month_num}`
          let ed = `${i}-${e.day_num}-${e.month_num}`
          let cat = categoryDD.find((x) => x.id === e.category_id)
          let catName = (cat && cat.name) || ''
          let type = cat && cat.type.find((x) => x.id.toString() === e.type_id)
          let typeName = (type && type.name) || ''

          let event = {
            start: new Date(d),
            startDate: new Date(d),
            isAllDay: true,
            end: new Date(ed),
            endDate: new Date(ed),
            title: e.titre,
            location: e.lieux,
            type: typeName,
            category: catName,
            event_type: e.event_type,
            pays: e.pays,
            designation: e.designation,
            region: e.region,
          }
          allEvents.push(event)
        }
      }
    })
  }

  const syncCalender = async (val) => {
    const res = await makeGetRequest(`/api/user/sync-calender/${val}/`, {}, true)
    if (res.status === 201) {
      setAddGooglContact(true)
    } else if (res.status === 200 && res.data.push_results) {
      // LAP-614: Show bidirectional sync results
      const push = res.data.push_results
      if (push.total_processed > 0) {
        console.log(
          `Sync completed!\n` +
          `Imported events from ${val}\n` +
          `Pushed ${push.successful} Life events to ${val}\n` +
          `Excluded: ${push.excluded}, Failed: ${push.failed}`
        )
      }
    }
    getAllEvents()
  }
  
  const getAllEvents = async () => {
    // setFinalEvents([])
    const res1 = await makeGetRequest('/api/time/get-events', {}, true)
    const res2 = await makeGetRequest('/api/time/get-category-dd', {}, true)
    // console.log(res1)
    // console.log(res2)
    // return
    if (res1.status === 200 && res2.status === 200) {
      const events = res1.data
      // filter appointment events
      const customEvents = events.filter((x) => x.event_type === 'a')
      let event_list = []
      customEvents.forEach((event) => {
        let sDate = event.start_date ? event.start_date.substring(0, 2) : ''
        let sMonth = event.start_date ? event.start_date.substring(3, 5) : ''
        let sYear = event.start_date ? event.start_date.substring(6, 10) : ''

        var [hour = '00', minute = '01'] = (event.start_time || '00:01').split(':')

        const startDate = new Date(
          Number(sYear),
          Number(sMonth) - 1,
          Number(sDate),
          Number(hour),
          Number(minute),
          0,
          0,
        )

        let eDate = event.end_date ? event.end_date.substring(0, 2) : ''
        let eMonth = event.end_date ? event.end_date.substring(3, 5) : ''
        let eYear = event.end_date ? event.end_date.substring(6, 10) : ''

        var [hour2 = '23', minute2 = '59'] = (event.end_time || '23:59').split(':')

        const endDate = new Date(
          Number(eYear),
          Number(eMonth) - 1,
          Number(eDate),
          Number(hour2),
          Number(minute2),
          0,
          0,
        )

        let cat = res2.data.find((x) => x.id === event.category_id)
        let catName = (cat && cat.name) || ''
        let type = cat && cat.type.find((x) => x.id.toString() === event.type_id)
        let typeName = (type && type.name) || ''

        event.title = event.titre
        event.start = startDate
        event.end = endDate
        event.startTime = event.start_time
        event.endTime = event.end_time
        event.location = event.lieux
        event.isAllDay = event.is_all_day
        event.type = typeName
        event.category = catName
        event_list.push(event)
        // allEvents.push(event)
      })
      // console.log(event_list)
      // createFixedEvents(events, res2.data)
      setFinalEvents(event_list)
      setFinalEventsTemp(event_list)
      // setDefaultView('year')
    }
  }
  // console.log(finalEvents)
  useEffect(() => {
    getAllEvents()
    getTaskList()
  }, [])
  useEffect(() => {
    setCalendarView(getCalendarViewFromSearch(location.search))
    setCalendarDate(getCalendarDateFromSearch(location.search))
  }, [location.search])
  // useEffect(() => {
  //   getAllEvents()
  // }, [finalEvents])

  // const localizer = momentLocalizer(moment) // or globalizeLocalizer
  // localizer.formats.yearHeaderFormat = 'YYYY'
  const [showModal, setShowModal] = useState(false)
  const toggleModal = useCallback(() => {
    setShowModal(!showModal)
  })

  const eventPropGetter = useCallback((event, start, end, isSelected) => {
    const border = getColor(event.type)
    
    // LAP-614: Differentiate internal vs external events
    let backgroundColor = '#adb9ca' // default
    
    if (event.event_type === 'f') {
      backgroundColor = '#d86565'
    } else if (event.calendar_type === 'extern') {
      // External events (from Google/Microsoft) - lighter shade with pattern
      backgroundColor = '#e8eef5'
    } else if (event.calendar_type === 'intern' && event.origin_calendar === 'Life') {
      // Internal Life events - default color
      backgroundColor = '#adb9ca'
    }
    
    var style = {
      borderRadius: '6px',
      border: `px solid ${getColor(event.type)}`,
      borderLeft: `10px solid ${border}`,
      fontWeight: '400',
      fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
      backgroundColor: backgroundColor,
      opacity: event.calendar_type === 'extern' ? 0.85 : 1,
    }
    
    return {
      style: style,
      className: event.type.toLowerCase(),
    }
  })

  const onDropEventMove = async (props) => {
    const { event, start, end } = props
    let sDate = start ? start.getDate() : ''
    let sMonth = start ? start.getMonth() + 1 : ''
    let sYear = start ? start.getFullYear() : ''
    let sHour = start ? start.getHours() : ''
    let sMinute = start ? start.getMinutes() : ''

    const startDate = `${sYear}-${sMonth}-${sDate}`

    event.start_date = startDate
    event.start_time = `${sHour}:${sMinute}`

    let eDate = end ? end.getDate() : ''
    let eMonth = end ? end.getMonth() + 1 : ''
    let eYear = end ? end.getFullYear() : ''
    let eHour = start ? end.getHours() : ''
    let eMinute = start ? end.getMinutes() : ''

    const endDate = `${eYear}-${eMonth}-${eDate}`

    event.end_date = endDate
    event.end_time = `${eHour}:${eMinute}`

    const res1 = await makePutRequest(`/api/time/events/${event.id}/`, event, {}, true)
    // const res1 = await makePostRequest(`/api/time/events/`, event, {}, true)
    if (res1.status === 200) {
      getAllEvents()
    }
  }
  const onDropEventCopy = async (props) => {
    const { event, start, end } = props
    let sDate = start ? start.getDate() : ''
    let sMonth = start ? start.getMonth() + 1 : ''
    let sYear = start ? start.getFullYear() : ''
    let sHour = start ? start.getHours() : ''
    let sMinute = start ? start.getMinutes() : ''

    const startDate = `${sYear}-${sMonth}-${sDate}`

    event.start_date = startDate
    event.start_time = `${sHour}:${sMinute}`

    let eDate = end ? end.getDate() : ''
    let eMonth = end ? end.getMonth() + 1 : ''
    let eYear = end ? end.getFullYear() : ''
    let eHour = start ? end.getHours() : ''
    let eMinute = start ? end.getMinutes() : ''

    const endDate = `${eYear}-${eMonth}-${eDate}`

    event.end_date = endDate
    event.end_time = `${eHour}:${eMinute}`

    // const res1 = await makePutRequest(`/api/time/events/${event.id}/`, event, {}, true)
    const res1 = await makePostRequest(`/api/time/events/`, event, {}, true)
    if (res1.status === 201) {
      getAllEvents()
    }
  }
  const onDropResizeEvent = async (props) => {
    const { event, start, end } = props
    let sDate = start ? start.getDate() : ''
    let sMonth = start ? start.getMonth() + 1 : ''
    let sYear = start ? start.getFullYear() : ''
    let sHour = start ? start.getHours() : ''
    let sMinute = start ? start.getMinutes() : ''

    const startDate = `${sYear}-${sMonth}-${sDate}`

    event.start_date = startDate
    event.start_time = `${sHour}:${sMinute}`

    let eDate = end ? end.getDate() : ''
    let eMonth = end ? end.getMonth() + 1 : ''
    let eYear = end ? end.getFullYear() : ''
    let eHour = start ? end.getHours() : ''
    let eMinute = start ? end.getMinutes() : ''

    const endDate = `${eYear}-${eMonth}-${eDate}`

    event.end_date = endDate
    event.end_time = `${eHour}:${eMinute}`

    const res1 = await makePutRequest(`/api/time/events/${event.id}/`, event, {}, true)
    if (res1.status === 200) {
      getAllEvents()
    }
  }

  const onClickSlot = (slot) => {
    const elements = document.getElementsByClassName('ppevent')
    Array.from(elements).forEach((el) => el.click())
    setSlot(slot)
    setShowModal(true)
  }
  const closeOpen = () => {
    setAddGooglContact(false)
  }
  const getTaskList = async () => {
    const res = await makeGetRequest('/api/mestodo/getTasks/', {}, true)
    if (res.status === 200) {
      setTaskList(res.data)
    }
  }
  const handleQueClose = () => {
    setPropsQue(false)
    setOpenQue(false)
  }
  const handleDragTaskAdd = async (slotData, taskData) => {
    const { start, end } = slotData
    let sDate = start ? start.getDate() : ''
    let sMonth = start ? start.getMonth() + 1 : ''
    let sYear = start ? start.getFullYear() : ''
    let sHour = start ? start.getHours() : ''
    let sMinute = start ? start.getMinutes() : ''

    const startDate = `${sYear}-${sMonth}-${sDate}`

    let eDate = end ? end.getDate() : ''
    let eMonth = end ? end.getMonth() + 1 : ''
    let eYear = end ? end.getFullYear() : ''
    let eHour = start ? end.getHours() : ''
    let eMinute = start ? end.getMinutes() : ''

    const endDate = `${eYear}-${eMonth}-${eDate}`

    const payload = {
      EventData: {
        start_time: '00:00',
        end_time: '01:00',
        start_date: startDate,
        end_date: startDate,
        titre: taskData.Nom,
      },
    }
    const response = await makePutRequest(
      urls.taskOperations + taskData.id + '/',
      payload,
      {},
      true,
    )
    if (response.status === 200) {
      getAllEvents()
      getTaskList()
    }
  }
  return (
    <>
      {openQue && (
        <Dialog
          open={true}
          onClose={handleQueClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{'   '}</DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleQueClose}
            sx={(theme) => ({
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'black',
            })}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent>
            <DialogContentText sx={{ px: 5, color: 'black', fontWeight: 700 }}>
              {/* LAP-733 (GE022) */}
              {t('time.dlgWhatTitle')}
            </DialogContentText>
          </DialogContent>
          <DialogActions
            sx={{ display: 'flex', justifyContent: 'center', '.MuiButton-root': { px: 5 } }}
          >
            <Button
              variant="contained"
              onClick={async () => {
                await onDropEventCopy(propsQue)
                handleQueClose()
              }}
            >
              {t('time.dlgCopy')}
            </Button>
            <Button
              variant="contained"
              onClick={async () => {
                await onDropEventMove(propsQue)
                handleQueClose()
              }}
            >
              {t('time.dlgMove')}
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {addGooglContact && <AddConnection updateList={closeOpen} openM={true} />}
      <Box sx={{ display: 'flex', width: '100%' }}>
        {/* Left Side Collapsible Drawer */}
        {!isMobile && (
          <Drawer
            sx={{
              width: openD ? 300 : 5,
              minWidth: openD ? 300 : 5,
              flexShrink: 0,
              transition: '0.3s ease-in-out',
              '& .MuiDrawer-paper': {
                position: 'relative',
                overflow: 'unset',
                width: openD ? 300 : 5,
                minWidth: openD ? 300 : 5,
                transition: '0.3s ease-in-out',
                background: 'gray',
                color: 'white',
              },
              '& .MuiList-root': { height: '100%', overflowX: 'auto' },
            }}
            variant="persistent"
            anchor="left"
            open={isMobile ? false : true}
          >
            <Box
              sx={{ position: 'absolute', right: '-25px', cursor: 'pointer', background: 'gray' }}
              onClick={handleDrawerToggle}
            >
              {openD ? (
                <KeyboardArrowLeftIcon sx={{ color: 'white' }} />
              ) : (
                <KeyboardArrowRightIcon sx={{ color: 'white' }} />
              )}
            </Box>
            {openD && (
              <Box sx={{ height: '92vh' }}>
                <List>
                  <ListItem sx={{ background: '#35425b' }}>
                    {/* LAP-733 (GE022) */}
                    <ListItemText
                      primary={t('time.sidebarFavorites')}
                      sx={{
                        '.MuiTypography-root': {
                          fontWeight: 700,
                          fontSize: '1.2rem',
                        },
                      }}
                    />
                  </ListItem>
                  {taskList.map((task, index) => {
                    if (task.favorite) {
                      return (
                        <ListItem
                          draggable
                          onDrag={() => {
                            setDragTask(task)
                          }}
                          // onDragEnd={()=>{setDragTask(false)}}
                          key={index}
                          sx={{
                            borderLeft: '10px solid #315385',
                            marginBottom: '3px',
                            ':hover': { background: '#919191' },
                          }}
                        >
                          {/* <ListItemIcon>
                            {favoriteTasks.includes(1) ? <StarIcon /> : <StarBorderIcon />}
                          </ListItemIcon> */}
                          <ListItemText sx={{ cursor: 'grab' }} primary={task.Nom} />
                          <ListItemIcon sx={{ cursor: 'pointer', justifyContent: 'end' }}>
                            <TodayIcon sx={{ color: 'white' }} onClick={() => setShowModal(true)} />
                            <StarIcon
                              sx={{ color: 'yellow', ml: 1 }}
                              onClick={() => toggleFavorite(task)}
                            />
                          </ListItemIcon>
                        </ListItem>
                      )
                    } else return ''
                  })}

                  <Divider />
                  <ListItem sx={{ background: '#35425b' }}>
                    {/* LAP-733 (GE022) */}
                    <ListItemText
                      sx={{ '.MuiTypography-root': { fontWeight: 700, fontSize: '1.2rem' } }}
                      primary={t('time.sidebarTaskSelection')}
                    />
                  </ListItem>
                  {taskList.map((task, index) => {
                    if (!task.Evenements && !task.favorite) {
                      return (
                        <ListItem
                          draggable
                          onDrag={() => {
                            setDragTask(task)
                          }}
                          key={index}
                          sx={{
                            borderLeft: '10px solid #315385',
                            marginBottom: '3px',
                            ':hover': { background: '#919191' },
                          }}
                        >
                          {/* <ListItemIcon>
                            {favoriteTasks.includes(1) ? <StarIcon /> : <StarBorderIcon />}
                          </ListItemIcon> */}
                          <ListItemText sx={{ cursor: 'grab' }} primary={task.Nom} />
                          <ListItemIcon sx={{ cursor: 'pointer', justifyContent: 'end' }}>
                            <TodayIcon sx={{ color: 'white' }} onClick={() => setShowModal(true)} />
                            <StarBorderIcon
                              sx={{ color: 'white', ml: 1 }}
                              onClick={() => toggleFavorite(task)}
                            />
                          </ListItemIcon>
                        </ListItem>
                      )
                    } else return ''
                  })}
                </List>
              </Box>
            )}
          </Drawer>
        )}

        {/* Right Side Content */}
        {/* <Box
          component="main"
          sx={{
            flexGrow: 1,

            p: 3,
          }}
        > */}
        <div
          style={{
            backgroundColor: '#00001D',
            fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
            width: '100%',
          }}
        >
          <Container
            className="scheduler-container"
            style={{ backgroundColor: '#00001D', color: 'white' }}
          >
            <Box style={{ display: 'flex', alignItems: 'center' }}>
              <Box>
                {/* <InputLabel sx={{ color: 'white' }} id="dropdown-label">
                Sync
              </InputLabel>
              <Select
                sx={{ '.MuiSelect-select': { padding: '2.5px 8px' } }}
                style={{
                  color: 'white',
                  width: '200px',
                  border: '1px solid #f1f1f1',
                }}
                labelId="dropdown-label"
                value={sync}
                onChange={(e) => setSync(e.target.value)}
              >
                <MenuItem value="select">Selectionez</MenuItem>
                <MenuItem value="google">Google</MenuItem>
                <MenuItem value="microsoft">Microsoft</MenuItem>
              </Select> */}
                <Button
                  variant="contained"
                  id="basic-button"
                  aria-controls={openn ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openn ? 'true' : undefined}
                  onClick={handleClick}
                >
                  {/* LAP-733 (GE022) */}
                  {t('time.btnSync')}
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={openn}
                  onClose={() => handleClose('')}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                >
                  <MenuItem onClick={() => handleClose('Google')}>Google</MenuItem>
                  <MenuItem onClick={() => handleClose('Microsoft')}>Microsoft</MenuItem>
                </Menu>
              </Box>
              
              {/* LAP-614: Push Life events to external calendars */}
              <Box ml={2}>
                <Button
                  id="basic-button2"
                  aria-controls={openn2 ? 'basic-menu2' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openn2 ? 'true' : undefined}
                  onClick={handleClick2}
                  variant="contained"
                >
                  {/* LAP-733 (GE022) — Google/Microsoft are proper nouns,
                      only the "all" variant is localized. */}
                  {selectedCalender === 'all' ? t('time.btnAll') : selectedCalender}
                </Button>
                <Menu
                  id="basic-menu2"
                  anchorEl={anchorEl2}
                  open={openn2}
                  // onClose={handleClose2}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button2',
                  }}
                >
                  <MenuItem onClick={() => handleClose2('all')}>{t('time.btnAll')}</MenuItem>
                  <MenuItem onClick={() => handleClose2('Google')}>Google</MenuItem>
                  <MenuItem onClick={() => handleClose2('Microsoft')}>Microsoft</MenuItem>
                </Menu>
                {/* <InputLabel sx={{ color: 'white' }} id="dropdown-label">
                Selectionez un platform
              </InputLabel>
              <Select
                sx={{ '.MuiSelect-select': { padding: '2.5px 8px' } }}
                style={{
                  color: 'white',
                  width: '200px',
                  border: '1px solid #f1f1f1',
                }}
                labelId="dropdown-label"
                value={platform}
                onChange={(e) => setPlatform(e.target.value)}
              >
                <MenuItem value="all">tout</MenuItem>
                <MenuItem value="Google">Google</MenuItem>
                <MenuItem value="Microsoft">Microsoft</MenuItem>
              </Select> */}
              </Box>
              <CustomButton
                style={{ marginLeft: 'auto' }}
                // className="create-btn"
                onClick={() => {
                  toggleModal()
                }}
              >
                {/* LAP-733 (GE022) */}
                {t('time.btnCreate')}
              </CustomButton>
            </Box>
            <br />
            <DnDCalendar
              className="muiCalanderlife"
              // LAP-733 (GE022) — culture is now driven by the active i18next
              // language so moment formats (dates, months, days) follow suit.
              culture={activeCulture}
              // dayLayoutAlgorithm={'no-overlap'}
              defaultView={calendarView}
              view={calendarView}
              date={calendarDate}
              onView={setCalendarView}
              onNavigate={setCalendarDate}
              style={{
                height: 800,
                // overflowY: 'scroll',
                width: '100%',
              }}
              selectable={true}
              longPressThreshold={10}
              draggableAccessor={() => true}
              onDropFromOutside={(slot) => {
                handleDragTaskAdd(slot, dragTask)
              }}
              onSelectSlot={(slot) => {
                onClickSlot(slot)
              }}
              onEventDrop={(props) => {
                setOpenQue(true)
                setPropsQue(props)
              }}
              onEventResize={(props) => onDropResizeEvent(props)}
              onSelectEvent={(event) => {
                // const elements = document.getElementsByClassName('ppevent')
                // console.log(elements)
                // Array.from(elements).forEach((el) => {
                //   console.log(el)
                //   el.click()
                // })
                // console.log(event)
                // console.log(`fevent_${event.id}_${event.index}`)
                let evid = document.getElementById(`fevt${event.id}`)
                if (evid) {
                  evid.click()
                }
              }}
              timeslots={1}
              step={60}
              localizer={localizer}
              events={finalEvents}
              toolbar={true}
              views={{
                day: true,
                week: true,
                month: true,
                agenda: true,
                year: Year,
              }}
              components={{
                month: { event: MonthEvent },
                week: { event: Event },
                day: { event: Event },
                year: { event: YearEvent },
                agenda: { event: CustomAgendaEvent },
              }}
              // getAllEvents={getAllEvents}
              // LAP-733 (GE022) — toolbar messages now go through i18next.
              messages={{
                previous: '<',
                next: '>',
                today: t('time.toolbarToday'),
                month: t('time.toolbarMonth'),
                week: t('time.toolbarWeek'),
                day: t('time.toolbarDay'),
                agenda: t('time.toolbarAgenda'),
                year: t('time.toolbarYear'),
                getAllEvents: getAllEvents,
              }}
              eventPropGetter={eventPropGetter}
              formats={{
                dayRangeHeaderFormat: ({ start, end }, culture, localizer) =>
                  localizer.format(start, 'D', culture) +
                  ' - ' +
                  localizer.format(end, 'D MMMM YYYY', culture),
                dayHeaderFormat: (date, culture, localizer) =>
                  localizer.format(date, 'dddd D MMMM YYYY', culture),
                yearHeaderFormat: 'YYYY',
              }}
            />
          </Container>
          {showModal && (
            <FormModal
              isOpen={showModal}
              getAllEvents={getAllEvents}
              toggleModal={toggleModal}
              /* LAP-733 (GE022) */
              title={t('time.eventDefaultTitle')}
              slot={slot}
            />
          )}
        </div>
      </Box>
      {/* </Box> */}
    </>
  )
}

export default Schedule
